import { ReactNode } from 'react'

const Scroll = ({ children, classNames }: { children: ReactNode; classNames?: string }) => {
  return (
    <div
      className={`
      ${classNames}
      overflow-y-auto whitespace-nowrap
      [&::-webkit-scrollbar-thumb]:cursor-pointer
      [&::-webkit-scrollbar-track]:cursor-pointer
      [&::-webkit-scrollbar]:h-3
      [&::-webkit-scrollbar]:w-2
  
      /* Light mode */
      [&::-webkit-scrollbar-track]:bg-neutral-2
      [&::-webkit-scrollbar-thumb]:bg-neutral-5
  
      /* Dark mode */
      dark:[&::-webkit-scrollbar-track]:bg-neutral-7
      dark:[&::-webkit-scrollbar-thumb]:bg-neutral-10
  
      [&::-webkit-scrollbar-track]:rounded-full
      [&::-webkit-scrollbar-thumb]:rounded-full
    `}
    >
      {children}
    </div>
  )
}

export default Scroll
